"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_instructor_service_area_map_html_1 = __importDefault(require("./admin-instructor-service-area-map.html"));
var admin_instructor_service_area_map_controller_1 = __importDefault(require("./admin-instructor-service-area-map.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.instructors.serviceareamap", {
        url: "/service-area-map",
        controller: admin_instructor_service_area_map_controller_1.default,
        controllerAs: "vm",
        template: admin_instructor_service_area_map_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.instructors.serviceareamap", [])
    .config(config)
    .controller("AdminInstructorServiceAreaMapController", admin_instructor_service_area_map_controller_1.default);
